<template functional>
  <div v-if="props.item.drayage_mode == 'rail'">—</div>
  <div v-else>{{ props.item.line_lfd_fmt }}</div>
</template>

<script>
export default {
  name: "drayage-line-lfd",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>
